export default {
  'Custom': 'Personnalisation',
  'Original': 'Original',
  'Resolution': 'Résolution',
  'Frame rate': "Fréquence d'images",
  'The higher the frame rate, the smoother the animation': "Plus la fréquence d'images est élevée, plus l'animation est fluide.",
  'Start': 'Début',
  'End': 'Fin',
  'Create GIF': 'Créez un GIF',
  'Download GIF': 'Téléchargez un GIF',
  'Create A New One': 'Créez un nouveau fichier',
  'Remake GIF': 'Transformez un GIF',
  'HitPaw Video to GIF Online': 'HitPaw Vidéo En GIF En Ligne',
  'Upload and convert video to GIF without any difficulty': 'Téléchargez et convertissez la vidéo en GIF sans aucune difficulté.',
}